export const VehicleIcon = ({
    color = "#A7A7A7",
    width = 19,
    height = 16,
    ...props
}) => (
    <svg width={width} height={height} viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M1.90667 0.88375C2.09 0.3675 2.60333 0 3.20833 0H13.2917C13.8967 0 14.4008 0.3675 14.5933 0.88375L16.5 6.125V13.125C16.5 13.6062 16.0875 14 15.5833 14H14.6667C14.1625 14 13.75 13.6062 13.75 13.125V12.25H2.75V13.125C2.75 13.6062 2.3375 14 1.83333 14H0.916666C0.4125 14 0 13.6062 0 13.125V6.125L1.90667 0.88375ZM12.375 9.625C13.1358 9.625 13.75 9.03875 13.75 8.3125C13.75 7.58625 13.1358 7 12.375 7C11.6142 7 11 7.58625 11 8.3125C11 9.03875 11.6142 9.625 12.375 9.625ZM4.125 9.625C4.88583 9.625 5.5 9.03875 5.5 8.3125C5.5 7.58625 4.88583 7 4.125 7C3.36417 7 2.75 7.58625 2.75 8.3125C2.75 9.03875 3.36417 9.625 4.125 9.625ZM13.9242 4.375L12.9708 1.75H3.53833L2.585 4.375H13.9242Z" fill={color} />
    </svg>
);
